import { TripRoomPaymentRequest } from "@cruisen/contract"

import { ITripRoom } from "@cruisen/contract"
import { _t } from "@cruisen/i18n"
import { toJS } from "mobx"

export const getCardInfo = (
  bookingDetails: ITripRoom["bookingDetails"],
): {
  cabinLocation: string
  cabinName: string
} | null => {
  if (
    bookingDetails === null ||
    (!bookingDetails.deckName && !bookingDetails.cabinNo && !bookingDetails.cabinName)
  )
    return null

  return {
    cabinLocation: `${bookingDetails.deckName} • ${_t("roomCard.cabin")} ${bookingDetails.cabinNo}`,
    cabinName: `${bookingDetails.cabinName}`,
  }
}

export const getPaymentRequestList = (room: ITripRoom) => {
  const paymentRequests = toJS(room?.paymentRequests) as unknown as Map<
    string,
    TripRoomPaymentRequest
  >

  const paymentRequestList = paymentRequests ? Array.from(paymentRequests.values()) : []
  return paymentRequestList
}
